import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'app-reports',
  template: require('./reports.component.html')
})
export class ReportsComponent extends BaseComponent implements OnInit {


  public onlyDemo = false;

  public onlyDemoToggled() {
    this.loadOrganizationsForReportSelect();
  }

  public progressStatus = "Please wait...";
  public progressTitle = "Progress";
  public progressValue = 0;
  public progressCurrent = 0;
  public progressTotal = 0;

  public showProgress(reset = false) {
    if(reset) {
      this.progressStatus = "Please wait...";
      this.progressTitle = "Progress";
      this.progressValue = 0;
      this.progressCurrent = 0;
      this.progressTotal = 0;
    }
    this.updateProgressValue();
    $("#myProgress").modal("show");
  }

  public updateProgressValue() {
    this.progressValue = Math.round(this.progressCurrent / this.progressTotal * 100);
    if(this.progressValue>100)
      this.progressValue = 100;
    if(this.progressValue<0)
      this.progressValue = 0;
  }

  public hideProgress() {
    $("#myProgress").modal("hide");
    this.busy = null;
    this.loadDistributedSurveys();
  }

  public getSurveyByBatchNumber(batchNumber) {
    var sur = null 
    this.distributedSurveys.forEach(survey => {
      if(survey.batchNumber == batchNumber) {
        if(sur==null)
          sur = survey;
      }
    });
    return sur;
  }

  public downloadOrgExcel() {
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }
      this.busy = this.lsApi.generateReportForOrgInExcel(orgId).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Excel Report Successfully Generated","Excel Report Generated");
            window.location.href = "/resources/organization/report/" + this.lsApp.getCurrentAuthToken() + "/" + orgId + "/" + resp.data[0], "_blank";
        }
    },
    error => {
        console.log(error);
    });  
  }


  public bulk_generateReport() { this.bulk_action_queue('generate'); }
  public bulk_downloadReport() { this.bulk_action_queue('downloadreport'); }
  public bulk_sendReportEmails() { this.bulk_action_queue('sendreport'); }
  public bulk_downloadExcelReport() { this.bulk_action_queue('downloadexcel'); }

  public bulk_action_queue(action) {

    var x = $(".slave:checked").length;
    if(x<=0) { bootbox.alert("Please select at least one item to continue"); return; }

    var action_text = "";
    switch(action) {
      case "generate":
        action_text = "Generate Report";
      break;
      case "sendreport":
        action_text = "Start Sending Report Emails";
      break;
      case "downloadreport":
        action_text = "Download Report";
      break;
      case "downloadexcel":
        action_text = "Download Excel Report";
      break;
      default:
        action_text = action;
    }


    bootbox.confirm({message:"Do you want to '" + action_text + "' for " + x + " survey(s)?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          var batchNumbers = "";
          for(var i=0;i<$(".slave:checked").length;i++) {
            var batchNumber = $(".slave:checked")[i].value;
            batchNumbers += "," + batchNumber;
          }
          if(batchNumbers.length>0)
            batchNumbers = batchNumbers.substring(1);

          this.busy = this.lsApi.bulkActionQueueModify(action, batchNumbers).subscribe(resp => {
              if(resp.status) {  
                  //this.appToast.success("Bulk Action '" + action_text + "' Successfully Queued","Bulk Action");

                  bootbox.alert(resp.message);

                  //window.location.href = "/resources/organization/report/" + this.lsApp.getCurrentAuthToken() + "/" + orgId + "/" + resp.data[0], "_blank";
              }
          },
          error => {
              console.log(error);
          }); 


        }
      }});


  }

  public bulk_stopSurvey() {

    var x = $(".slave:checked").length;
    if(x<=0) { bootbox.alert("Please select at least one item to continue"); return; }
    bootbox.confirm({message:"Do you want to stop " + x + " survey(s)?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.progressCurrent = 0;
          this.progressTotal = x;
          this.progressTitle = "Stopping Surveys";
          this.progressStatus = "Please wait...";
          this.showProgress();
          this._bulkStopSurveys();


        }
      }});
  }

  public _bulkStopSurveys() {
    if(this.progressCurrent>= this.progressTotal) {
      this.hideProgress();
      bootbox.alert("Surveys successfully stopped");
      return;
    }
    var batchNumber = $(".slave:checked")[this.progressCurrent].value;
    var survey = this.getSurveyByBatchNumber(batchNumber);
    
    if(survey!=null) {
      this.progressStatus = "Stopping survey titled '" + survey.title + "'";
    }
    else {
      this.progressStatus = "Please wait...";
    }
    this.busy = this.lsApi.stopDistributedSurveysByBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {
            this.progressCurrent++;
            this.updateProgressValue();
            this._bulkStopSurveys();
        }
    },
    error => {
        console.log(error);
    });
  }

  public bulk_resumeSurvey() {
    var x = $(".slave:checked").length;
    if(x<=0) { bootbox.alert("Please select at least one item to continue"); return; }
    bootbox.confirm({message:"Do you want to resume " + x + " survey(s)?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {     

          this.progressCurrent = 0;
          this.progressTotal = x;
          this.progressTitle = "Resuming Surveys";
          this.progressStatus = "Please wait...";
          this.showProgress();
          this._bulkResumeSurveys();


        }
      }});
  }


  public _bulkResumeSurveys() {
    if(this.progressCurrent>= this.progressTotal) {
      this.hideProgress();
      bootbox.alert("Surveys successfully resumed");
      return;
    }
    var batchNumber = $(".slave:checked")[this.progressCurrent].value;
    var survey = this.getSurveyByBatchNumber(batchNumber);
    
    if(survey!=null) {
      this.progressStatus = "Resuming survey titled '" + survey.title + "'";
    }
    else {
      this.progressStatus = "Please wait...";
    }
    this.busy = this.lsApi.resumeDistributedSurveysByBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {
            this.progressCurrent++;
            this.updateProgressValue();
            this._bulkResumeSurveys();
        }
    },
    error => {
        console.log(error);
    });
  }

  public bulk_remindSurvey() {
    var x = $(".slave:checked").length;
    if(x<=0) { bootbox.alert("Please select at least one item to continue"); return; }
    bootbox.confirm({message:"Do you want to send reminders for " + x + " survey(s)?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {     


          
          this.progressCurrent = 0;
          this.progressTotal = x;
          this.progressTitle = "Sending Surveys Reminders";
          this.progressStatus = "Please wait...";
          this.showProgress();
          this._bulkSendReminders();

        }
      }});
  }


  public sendReminderEmail(batchNumber) {
    this.busy = this.lsApi.sendSurveyReminders(batchNumber).subscribe(resp => {
        if(resp.status) {
          bootbox.alert("Reminders successfully sent");
        }
    },
    error => {
        console.log(error);
    });
  }

  public _bulkSendReminders() {
    if(this.progressCurrent>= this.progressTotal) {
      this.hideProgress();
      bootbox.alert("Reminders successfully sent");
      return;
    }
    var batchNumber = $(".slave:checked")[this.progressCurrent].value;
    var survey = this.getSurveyByBatchNumber(batchNumber);
    
    if(survey!=null) {
      this.progressStatus = "Sending reminders for survey titled '" + survey.title + "'";
    }
    else {
      this.progressStatus = "Please wait...";
    }
    this.busy = this.lsApi.sendSurveyReminders(batchNumber).subscribe(resp => {
        if(resp.status) {
            this.progressCurrent++;
            this.updateProgressValue();
            this._bulkSendReminders();
        }
    },
    error => {
        console.log(error);
    });
  }


  public bulk_deleteSurvey() {
    var x = $(".slave:checked").length;
    if(x<=0) { bootbox.alert("Please select at least one item to continue"); return; }
    bootbox.confirm({message:"Do you want to clear " + x + " survey(s) submissions?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {  
          
          
          this.progressCurrent = 0;
          this.progressTotal = x;
          this.progressTitle = "Clearing Surveys Submissions";
          this.progressStatus = "Please wait...";
          this.showProgress();
          this._bulkClearSurveys();


        }
      }});
  }



  public _bulkClearSurveys() {
    if(this.progressCurrent>= this.progressTotal) {
      this.hideProgress();
      bootbox.alert("Surveys submissions successfully cleared");
      return;
    }
    var batchNumber = $(".slave:checked")[this.progressCurrent].value;
    var survey = this.getSurveyByBatchNumber(batchNumber);
    
    if(survey!=null) {
      this.progressStatus = "Clearing submissions of survey titled '" + survey.title + "'";
    }
    else {
      this.progressStatus = "Please wait...";
    }
    this.busy = this.lsApi.deleteDistributedSurveyByBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {
            this.progressCurrent++;
            this.updateProgressValue();
            this._bulkClearSurveys();
        }
    },
    error => {
        console.log(error);
    });
  }




  public distributedSurveys = [];
  public organizations = [];

  public selectedOrganization = null;
  public selectedManagerId = -1;

  public managers = [];

  public surveys = [];
  public selectedSurveyId = -1;


  public organizationSelectionChanged() {
    this.selectedManagerId = -1;
    console.log(this.selectedOrganization);
    this.loadOrganizationManagers();
  }


  public loadOrganizationManagers() {
    if(this.selectedOrganization!=null)
      this.managers = this.selectedOrganization.managers;
    else 
      this.managers = [];
  }

  public surveyPercentage(s) {
    var perct = 0;
    perct = s.employeeCompletedCount / s.employeeCount * 100;
    return perct;
  }


  public getSurveySuspendText(survey) {

    if(survey.suspendSurvey == 0 && survey.suspendAnySurvey == 1) {
      return "Few Survey(s) Stopped";
    }
    else if(survey.suspendSurvey==1){
      return "All Survey(s) Stopped";
    }
    else {
      return "";
    }

  }

  public routeParamsUpdated() {
    
  }

  public updateTips(batchNumber) {


    bootbox.confirm({message:"Do you want to update tips from the original survey",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {     

            this.busy = this.lsApi.updateTips(batchNumber).subscribe(resp => {
              if(resp.status) {  
                bootbox.alert(resp.message +"<br><br>" + "<b>Added Tips: </b>" + resp.data[0].added + "<br><b>Missing Tips: </b>"  + resp.data[0].missing + "<br><b>Missing Details: </b><br>" + resp.data[0].missingDetails);
              }
          },
          error => {
              console.log(error);
          });  

        }
      }});

          

  }

  public toggleMasterCheckbox() {
    $(".slave").prop("checked",$(".master").prop("checked"))
  }

  public resendReportEmail(batchNumber) {

    this.busy = this.lsApi.resendReportEmailForBatchNumber(batchNumber).subscribe(resp => {
      if(resp.status) {  
          this.appToast.success(resp.message,"Report Email");
      }
  },
  error => {
      console.log(error);
  });      
  }

  public startEmailSending(batchNumber) {

    this.busy = this.lsApi.queueReportEmailForBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success(resp.message,"Report Email");
        }
    },
    error => {
        console.log(error);
    });      

  }

  public downloadExcel(batchNumber) {
    
  }
  
  public generateReport(batchNumber) {

    this.busy = this.lsApi.generateReportForDistributedSurveyBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + batchNumber + "/" + resp.data[0], "_blank";
        }
    },
    error => {
        console.log(error);
    });  
  }

  public viewReport(batchNumber) {

    this.busy = this.lsApi.viewReportForDistributedSurveyBatchNumber(batchNumber).subscribe(resp => {
        if(resp.status) {  
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + batchNumber + "/" + resp.data[0], "_blank";
        }
    },
    error => {
        console.log(error);
    });  
  }

  public datePipeEn: DatePipe = new DatePipe('en-US')
  public getEmailStats(dSurvey) {
    var lastEmailSent = dSurvey.lastEmailSent;
    if(lastEmailSent == null) {
      return "N/A";
    }
    else {
      var str = "";
      var status = lastEmailSent.mailgunEmailStatues[lastEmailSent.mailgunEmailStatues.length-1];
      var statusDate = this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy");
      var titleCase = new TitleCasePipe();
      str = titleCase.transform(lastEmailSent.emailType) + "<br>" + titleCase.transform(status.status) + " - <span title='" + this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy h:mm:ss a z") + "'>" + statusDate + "</span>"

      return str;
    }
  }
  
  public loadDistributedSurveys() {
    var vals = $(".slave:checked").map(function(){
      return $(this).val();
    }).get();
    var orgId = -1;
    if(this.selectedOrganization != null) {
      orgId = this.selectedOrganization.organizationId;
    }
    this.busy = this.lsApi.getDistributedSurveys(orgId, this.selectedManagerId, this.selectedSurveyId).subscribe(resp => {
        if(resp.status) {
            this.distributedSurveys = resp.data;
            if(this.distributedSurveys.length>0) {
              this.initDataTable(
                "#tblData",
                [
                  { "bSearchable": false, bSortable: false }, //col 1
                  { "bSearchable": true },  //col 2
                  { "bSearchable": true },  //col 3
                  { "bSearchable": true }, //col 4
                  { "bSearchable": false, bSortable: false }, //col 5
                  { "bSearchable": false, bSortable: false } //col 6 
                ]
              );
            }
            if(vals.length>0) {
              setTimeout(function(){
                vals.forEach(value => {
                  $(".slave[value='" + value + "']").prop("checked",true);
                });
              },0);
            }
        }
    },
    error => {
        console.log(error);
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadOrganizationsForReportSelect();
    this.getSurveysForSelect();
  }


  public loadOrganizationsForReportSelect() {
    this.busy = this.lsApi.getOrganizationsForReportSelect(this.onlyDemo).subscribe(resp => {
        if(resp.status) {
            this.organizations = resp.data;
            this.selectedOrganization = null;
            this.selectedManagerId = -1;
            this.loadOrganizationManagers();
        }
    },
    error => {
        console.log(error);
    });
  }


  public getSurveysForSelect() {
    this.lsApi.getSurveysForSelect().subscribe(resp => {
        if(resp.status) {
            this.surveys = resp.data;
            this.selectedSurveyId = -1;
        }
    },
    error => {
        console.log(error);
    });
  }



  public stopSurvey(s) {

  }

  public deleteSurvey(s) {

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/reports/reports.component.ts